import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import {
  isParameterDefinitionInOutFromParameterDetailsField,
  type ParameterDetailsField,
} from '../../../types/parameterModel'

type Props = {
  data: Optional<ParameterDetailsField>
}

export const ParameterDetailsTitle = ({ data }: Props) => {
  const translate = useTranslate()

  if (!data) {
    return null
  }

  return (
    <div className="w-full break-keep font-thin">
      {isParameterDefinitionInOutFromParameterDetailsField(data)
        ? data.name
        : translate('parameterViewer.parameterDetails.dimension.title', {
            dimensionName: data.name ?? '',
          })}
    </div>
  )
}
